/* eslint-disable react/prop-types */

import { FaEllipsisVertical, FaXmark } from "react-icons/fa6";

import { useDispatch, useSelector } from "react-redux";

import { setIsLoading, setNoteData, setOrderData, setPreOrderDateAndTimeData, setReplaceItemState, updateOrderCategoryStage, updateOrderType } from "@/redux/slice/take-order-slice/order-slice";

import { resetSelectedCustomer, setSelectedCustomer } from "@/redux/slice/take-order-slice/selected-customer-slice";

import { setCart } from "@/redux/slice/take-order-slice/cart-slice";

import { setDeliveryInfo } from "@/redux/slice/take-order-slice/delivery-slice";

import BackendToCartDataFormat from "@/lib/BackendToCartDataFormat";

import { AlarmClock } from "lucide-react";

import { setReduxFormatDateTime } from "@/lib/dateTimeConversion";

import toast from "react-hot-toast";

import { useState, useEffect, useRef } from "react";

import { TableIcon } from "./Icons";

import { getSingleOrderApi, orderReplaceItemApi, orderServingStatsApi } from "@/api/take-order/take-order";

import { Skeleton } from "@/components/ui/skeleton";

import { useNavigate } from "react-router-dom";

import FoodServingStatus from "./foodServingStatus";

import { useOnClickOutside } from "@/hooks/useOnClickOutside";

import PusherHandler from "@/api/lib/pusher/PusherHandler";

import { printCustomerCopy } from "@/lib/print-slip";

import { fullReplacedOrder } from "@/api/new-api/order-history/order-history";

import PrintKitchenCopyModal from "./PrintKitchenCopyModal";

import DelayOrderModal from "./DelayOrderModal";

import SpendOfferModal from "./SpendOfferModal";

import OrderedItemDetailsModal from "./OrderedItemDetailsModal";

import hasPermission from "@/hooks/hasPermission";
import getOrderAdvanceDetails from "@/lib/orderAdvanceUtils";
import { getOrderCustomerName, getOrderCustomerPhone } from "@/lib/utils";
import { OrderItemPriceDisplay, OrderItemComboBreakdown, OrderItemCourseBreakdown, OrderItemMixAndMatchBreakdown, OrderItemCustomizationBreakdown, OrderItemSpecialMenuBreakdown } from "./OrderItemComboBreakdown";



function OrderDetails({setCheckoutData, checkoutData, setBillPage, setSetTimePage, setConvertOrder, setActiveOrderSection, setComplementaryPage, setOrderDetailsId, orderDetailsId, redirectToTakeOrder = false}) {

    const [isTabletView, setIsTabletView] = useState(window.innerWidth <= 1200);

    const [replaceItem, setReplaceItem] = useState(null);

    const [viewItemDetails, setViewItemDetails] = useState(null);

    const [replaceSameItem, setReplaceSameItem] = useState(false);

    const [reason, setReason] = useState("");

    // const [order, setOrder] = useState({items: []});

    const { orderData: order, isLoading } = useSelector((state) => state.takeOrder.order);

    const advanceInfo = getOrderAdvanceDetails(order);
    const hasAdvance = advanceInfo.hasAdvance && advanceInfo.isPaid;
    const orderTotalAmount = Number(order?.order_total !== undefined && order?.order_total !== null ? order.order_total : (order?.subtotal || order?.total_price || 0));
    const totalToPayAmount = Number(order?.total_price !== undefined && order?.total_price !== null ? order.total_price : orderTotalAmount);
    const activeTableName = advanceInfo.tableName || order?.reservation?.table?.name || "";

    const [orderIdToReplace, setOrderIdToReplace] = useState(null);

    const [showReplaceOrderPopup, setShowReplaceOrderPopup] = useState(false);

    const [showKitchenPrintModal, setShowKitchenPrintModal] = useState(false);

    const [showDelayOrderModal, setShowDelayOrderModal] = useState(false);

    const [showSpendOfferModal, setShowSpendOfferModal] = useState(false);

    const dispatch = useDispatch();

    const navigate = useNavigate(); 

    const itemReplacePopupRef =  useRef(null);

    useEffect(() => {

        const handleResize = () => {

            setIsTabletView(window.innerWidth <= 1200);

        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);

    }, []);

    // const { orderData:order } = useSelector((state) => state.takeOrder.order);

    const isPaid = order?.payment_status === "paid" || order?.payment_status === "cash_on_delivery";

        

    const continueOrder = () => {

        if (isPaid) return toast.error("Order is paid. No changes allowed");

        const { cart, orderType, customer, delivery } = BackendToCartDataFormat(order);

        console.log("Continue Order Data --->", {cart, orderType, customer, delivery})

        // Here you can dispatch to redux or handle the cart data as needed

        setOrderDetailsId(null);

        dispatch(setCart(cart));

        // dispatch(updateOrderType(orderType)); 

        dispatch(setSelectedCustomer(customer ? { ...customer, number: customer?.number || order?.customer_number || "" } : null));

        dispatch(setDeliveryInfo(delivery));

        dispatch(setOrderData(order)); 

        dispatch(setNoteData(order?.note || "")); 

        dispatch(setPreOrderDateAndTimeData(setReduxFormatDateTime(order?.pre_order_date_and_time) || null));

        // setActiveOrderSection();

        dispatch(updateOrderType((order?.order_type == "pickup")? "Pickup" : (order?.order_type == "delivery")? "Delivery" :  (order?.order_type == "in_house")? "In-house" :  (order?.order_type == "table")? "Table" : "" ));

        console.log((order?.order_type == "pickup")? "Pickup" : (order?.order_type == "delivery")? "Delivery" :  (order?.order_type == "in_house")? "In-house" :  (order?.order_type == "table")? "Table" : "" );



        setActiveOrderSection("New Order");

        setCheckoutData({id: "", name: "", phone: "", type: "Pickup", date: "", items: [], notes: "", total: 0});



        if (redirectToTakeOrder) {

            navigate('/take-order');

        }

    }





    console.log("replaceItem", replaceItem)





    useOnClickOutside(itemReplacePopupRef,() => {

        setReplaceItem(null);

    });





        // Pusher for live update of food serving status



    const {

        connectionStatus: tableStatus,

        lastUpdate: lastTableUpdate,

        addEventHandler: addTableHandler,

        isConnected: tableConnected

    } = PusherHandler(); 



    useEffect(() => {

        console.log('🚀 Setting up table event handlers...');

        console.log('📡 Table connection status:', tableStatus);

        console.log('🔗 Is table connected:', tableConnected);

        





        addTableHandler('order-serving-status-updated', (data) => {



            dispatch(updateOrderCategoryStage(data.category_stage));

        })

        

    }, [addTableHandler, tableStatus, tableConnected]);





    function replaceSameItemConfirm (item){



        console.log("Confirming replace with same item:", item);

        

        orderReplaceItemApi(item?.order_id, {

            replacements:[{

                replaceItemId : item?.order_item_id,

                items: [{

                    id: item?.id,

                    menu_item_id: item?.menu_item_id,

                    order_item_id: item?.order_item_id,

                    quantity: item?.quantity

                }]}

            ],

            reason: reason

        }).then((res) => {

            console.log(res);

            if(res?.status == "success"){

                toast.success("Replace item confirmed successfully");

                dispatch(setOrderData(res?.data?.order));



                setReplaceSameItem(null); 

                setReplaceItem(null);

            }else{

                toast.error(res?.message);

                setReplaceSameItem(null); 

                setReplaceItem(null);

            }

        });



    }





    const handleReplaceOrder = (orderId) => {

        setOrderIdToReplace(orderId);

        setShowReplaceOrderPopup(true);

    };



    const confirmReplaceOrder = () => {

        replaceOrder(orderIdToReplace);

        setShowReplaceOrderPopup(false);

        setOrderIdToReplace(null);

    };



    const cancelReplaceOrder = () => {

        setShowReplaceOrderPopup(false);

        setOrderIdToReplace(null);

    };





    function replaceOrder(orderId){

        fullReplacedOrder(orderId).then((res) => {

            if(res?.status === "success"){

                toast.success("Order replaced successfully");

                setCheckoutData({id: "", name: "", phone: "", type: "Pickup", date: "", items: [], notes: "", total: 0});

                dispatch(setOrderData(null));

                dispatch(resetSelectedCustomer());

                // dispatch(resetBookingToRedux());

            }else{

                toast.error(res?.message || "Failed to replace order");

            }

        }).catch((err) => {

            console.error("Error replacing order:", err);

            toast.error("An error occurred while replacing the order");

        });

    }







  return (

    <div className={` z-20 shrink-0 ${isTabletView ? "w-[520px] h-[92vh] max-h-[760px]" : "w-[620px] h-[92vh] max-h-[880px]"} bg-color2 ${isTabletView ? "p-4" : "p-6"} rounded-md border-4 border-color3 relative flex flex-col justify-between overflow-hidden`}>

        <button onClick={()=> {setOrderDetailsId(null); dispatch(setOrderData(null)); dispatch(resetSelectedCustomer()); }} className={`absolute top-0 right-0 text-color8 float-right ${isTabletView ? "text-xl" : "text-2xl"} p-2`}><FaXmark/></button>

        

        {isLoading ? (

            // Skeleton Loading UI

            <div className={`w-full h-full flex flex-col justify-between`}>

                <div className="shrink-0">

                    <Skeleton className={`${isTabletView ? "h-7 w-32" : "h-8 w-40"} mx-auto mb-2`} />

                    <Skeleton className={`${isTabletView ? "h-4 w-24" : "h-5 w-28"} mx-auto mb-3`} />

                    {/* Order Info Skeleton */}

                    <div className={`w-full bg-color3 ${isTabletView ? "p-1.5 mb-1.5" : "p-2 mb-2"} rounded-sm`}>

                        <div className={`flex ${isTabletView ? "flex-col gap-1.5" : "flex-col gap-2"}`}>

                            {[...Array(3)].map((_, i) => (

                                <Skeleton key={`info-${i}`} className={`${isTabletView ? "h-4" : "h-5"} w-full`} />

                            ))}

                        </div>

                    </div>

                </div>

                {/* Items Section Skeleton */}

                <div className={`flex-1 min-h-0 flex flex-col my-1`}>

                    <Skeleton className={`${isTabletView ? "h-5 w-16" : "h-6 w-20"} mb-1`} />

                    <div className={`flex-1 min-h-0 overflow-auto`}>

                        {[...Array(4)].map((_, i) => (

                            <div key={`item-${i}`} className={`${isTabletView ? "mb-1.5 p-1" : "mb-2 p-2"} bg-color3`}>

                                <Skeleton className={`${isTabletView ? "h-4" : "h-5"} w-full mb-1`} />

                                <Skeleton className={`${isTabletView ? "h-3" : "h-4"} w-3/4`} />

                            </div>

                        ))}

                    </div>

                </div>

                <div className="shrink-0 flex flex-col gap-2">

                    {/* Notes Section Skeleton */}

                    <div>

                        <Skeleton className={`${isTabletView ? "h-5 w-16" : "h-6 w-20"} mb-1`} />

                        <div className={`bg-color3 ${isTabletView ? "p-1 h-[28px]" : "p-2 h-[36px]"}`}>

                            <Skeleton className={`h-full w-full`} />

                        </div>

                    </div>

                    {/* Total Section Skeleton */}

                    <div>

                        <div className={`bg-color3 ${isTabletView ? "p-1.5 mb-1" : "p-2 mb-1"}`}>

                            <Skeleton className={`${isTabletView ? "h-4" : "h-5"} w-full`} />

                        </div>

                    </div>

                    {/* Buttons Skeleton */}

                    <div className={`${isTabletView ? "gap-1.5" : "gap-2"} flex flex-col`}>

                        <div className={`flex ${isTabletView ? "gap-1.5" : "gap-2"}`}>

                            {[...Array(3)].map((_, i) => (

                                <Skeleton key={`btn-${i}`} className={`w-full ${isTabletView ? "h-8" : "h-10"} rounded-md`} />

                            ))}

                        </div>

                        <div className={`flex ${isTabletView ? "gap-1.5" : "gap-2"}`}>

                            {[...Array(3)].map((_, i) => (

                                <Skeleton key={`btn2-${i}`} className={`w-full ${isTabletView ? "h-8" : "h-10"} rounded-md`} />

                            ))}

                        </div>

                        <div className={`flex ${isTabletView ? "gap-1.5" : "gap-2"}`}>

                            {[...Array(3)].map((_, i) => (

                                <Skeleton key={`btn3-${i}`} className={`w-full ${isTabletView ? "h-8" : "h-10"} rounded-md`} />

                            ))}

                        </div>

                    </div>

                </div>

            </div>

        ) : (

            // Actual Content

        <>

            <div className="shrink-0">

                <h1 className={`${isTabletView ? "-mt-3 text-xl" : "-mt-4 text-2xl"} text-center font-semibold`}>Order Details</h1>

                {
                    order?.is_fully_replaced && (
                        <div className="flex justify-center mt-1 mb-2">
                            <span className="bg-orange-500/20 text-orange-400 border border-orange-500/40 px-3.5 py-1 rounded-md text-xs font-bold uppercase tracking-wider flex items-center gap-1.5 shadow-sm">
                                🔄 Replaced Order
                            </span>
                        </div>
                    )
                }

                {

                    isPaid && (

                        <h1 className={`font-bold ${isTabletView ? "mb-1 text-sm" : "mb-2 text-base"} uppercase text-color7 text-center`}> {order?.payment_status === "paid"? "Paid" : "Cash on Delivery"}</h1>

                    )

                }

                <h2 className={` mt-2 -mb-2 flex items-center justify-center gap-4 text-color6 text-center ${isTabletView ? "text-xs" : "text-sm"}`}> (#{order?.day_order_number})

                    {activeTableName && (

                        <div className="flex items-center gap-1">

                            <span><TableIcon className="w-4 h-4 stroke-color6" /></span>

                            <span className="text-color6">{activeTableName}</span>

                        </div>

                    )}

                </h2>

                {

                    order?.pre_order_date_and_time && order.stage == "pre_order" &&

                    <div className={`text-color7 font-semibold flex items-center justify-center ${isTabletView ? "gap-0.5 text-xs mt-0.5" : "gap-1 mt-1"}`}>

                            <AlarmClock className={`stroke-color7 ${isTabletView ? "w-4 h-4" : "w-5 h-5"}`} /> 

                            <span>{ new Date(order?.pre_order_date_and_time).toLocaleString()}</span>

                    </div>

                }

            </div>

            <div className={`w-full flex-1 min-h-0 flex flex-col justify-between ${isTabletView ? "mt-2" : "mt-3"}`}>

                    <div className={`w-full shrink-0 bg-color3 ${isTabletView ? "p-1.5" : "p-3"} grid grid-cols-2 gap-x-6 gap-y-2 rounded-sm`}>

                        <div className={`flex flex-col ${isTabletView ? "gap-1 text-xs" : "gap-2"} min-w-0`}>

                            <div className="flex items-center gap-2 min-w-0">

                                <div className={`${isTabletView ? "w-[75px]" : "w-[90px]"} font-semibold shrink-0`}>Order ID:</div> 

                                <span className="text-color6 truncate">{ order?.id}</span>

                            </div>

                            <div className="flex items-center gap-2 min-w-0">

                                <div className={`${isTabletView ? "w-[75px]" : "w-[90px]"} font-semibold shrink-0`}>Customer:</div>

                                <span className="text-color6 truncate" title={getOrderCustomerName(order, "Unknown")}>{getOrderCustomerName(order, "Unknown")}</span>

                            </div>

                            <div className="flex items-center gap-2 min-w-0">

                                <div className={`${isTabletView ? "w-[75px]" : "w-[90px]"} font-semibold shrink-0`}>Phone:</div>

                                <span className="text-color6 truncate">{getOrderCustomerPhone(order, "-")}</span>

                            </div>

                        </div>

                        <div className={`flex flex-col ${isTabletView ? "gap-1 text-xs" : "gap-2"} min-w-0`}>

                            <div className="flex items-center gap-2 min-w-0">

                                <div className={`${isTabletView ? "w-[60px]" : "w-[70px]"} font-semibold shrink-0`}>Type:</div>

                                <span className="text-color6 truncate">{(order?.order_type == "pickup")? "Pickup" : (order?.order_type == "delivery")? "Delivery" :  (order?.order_type == "in_house")? "In House" :  (order?.order_type == "table")? "Table" : "" }</span>

                            </div>

                            <div className="flex items-start gap-2 min-w-0">

                                <div className={`${isTabletView ? "w-[60px]" : "w-[70px]"} font-semibold shrink-0`}>Date:</div>

                                <span className="text-color6 break-words">{new Date(order?.created_at).toLocaleDateString()}</span>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full flex-1 min-h-0 flex flex-col ${isTabletView ? "my-1" : "my-1.5"}`}>

                        <h2 className={`font-semibold shrink-0 ${isTabletView ? "text-sm mb-0.5" : "text-base mb-1"}`}>Items</h2>

                        <div className={`flex-1 min-h-0 overflow-y-auto overflow-x-hidden pr-1`}>

                            {

                                order?.items.map((item, index) => (

                                    <>

                                    {/* replace Item */}

                                    {

                                        item?.is_replaced ?

                                        <div className={` ${isTabletView ? "mb-1.5" : "mb-2"} flex flex-col gap-[1px] border border-color4`}>

                                            <div title={item.is_complementary ? "Complementary Item" : ""} key={index} className={`${isTabletView ? " p-1 text-xs gap-2" : " p-2 gap-4"} bg-color3 flex items-center justify-center`}>

                                                <div className={`${isTabletView ? "w-[150px]" : "w-[220px]"} flex flex-col items-start justify-center`}>

                                                    <span>{item.name}</span>

                                                    {item.is_offer_discount && (

                                                        <span className=" text-[9px] bg-emerald-600/30 text-emerald-400 border border-emerald-500/50 px-1 py-0.2 rounded font-medium mt-0.5">

                                                            🏷️ Discount Offer

                                                        </span>

                                                    )}

                                                </div>

                                                <div className={`${isTabletView ? "w-[80px]" : "w-[120px]"}`}>

                                                    {

                                                        item?.variant?.name && <span className="text-color6">({item?.variant?.name})</span>

                                                    }

                                                    {

                                                        item?.size && <span className="text-color6">({item?.size})</span>

                                                    }

                                                    {

                                                        item.buffet_price_for && <span className="text-color6">({item.buffet_price_for == "adult" ? "Adult" : "Kids"})</span>

                                                    }

                                                    {/* <span className=" ml-2 px-2 py-[1px] bg-color8 text-xs rounded-full">Old</span> */}

                                                </div>

                                                <div>

                                                    <span className="text-color6">x{item.quantity}</span>

                                                </div>

                                                <OrderItemPriceDisplay item={item} orderType={order?.order_type} />

                                                {/* Replace Item */}

                                                <div className=" flex items-center justify-center p-2 -mr-2 relative">

                                                    <span onClick={()=> setReplaceItem(item)} className=" cursor-pointer"><FaEllipsisVertical /></span>

                                                    {

                                                        (replaceItem?.order_item_id === item?.order_item_id) &&

                                                        <div ref={itemReplacePopupRef} className=" w-[170px] bg-color2 flex flex-col gap-1 absolute z-20 top-0 right-1 p-2 border border-color3 rounded-md ">

                                                            <div onClick={()=> setReplaceItem(null)} className=" absolute top-1 right-1 text-red-600 cursor-pointer"><FaXmark size={20} /></div>

                                                            <div onClick={() => { setViewItemDetails(item); setReplaceItem(null); }} className=" hover:text-color6 cursor-pointer">View Details</div>

                                                            {

                                                                hasPermission("take_orders.take_order.replace_items") &&

                                                                <> 

                                                                    <div onClick={()=> setReplaceSameItem(item)} className=" hover:text-color6 cursor-pointer">Replace with same</div>

                                                                    {!(item.is_complementary || item.is_loyalty_free || item.is_offer_free || item.is_free || item.calculated_price === 0) && (
                                                                        <div onClick={()=>{ dispatch(setReplaceItemState(item)); setOrderDetailsId(null); setActiveOrderSection("New Order") }} className=" hover:text-color6 cursor-pointer">Replace with another</div>
                                                                    )}

                                                                </>

                                                            }

                                                            

                                                        </div>

                                                    }

                                                    

                                                </div>

                                            </div>

                                            <OrderItemComboBreakdown comboItems={item?.combo_items} isTabletView={isTabletView} />
                                            <OrderItemCourseBreakdown courseItems={item?.course_items} item={item} isTabletView={isTabletView} />
                                            <OrderItemSpecialMenuBreakdown specialMenu={item?.special_menu} item={item} isTabletView={isTabletView} />
                                            <OrderItemMixAndMatchBreakdown items={item?.mix_and_match_items || item?.selected_items || item?.categories} isTabletView={isTabletView} />
                                            <OrderItemCustomizationBreakdown item={item} isTabletView={isTabletView} />

                                            {

                                                item?.new_items && item?.new_items.map((item, index) => (

                                                    <div key={index} className="flex flex-col">

                                                        <div title={item.is_complementary ? "Complementary Item" : ""} className={`${isTabletView ? " p-1 text-xs gap-2" : " p-2 gap-4"} bg-color3 flex items-center justify-center`}>

                                                            <div className={`${isTabletView ? "w-[150px]" : "w-[220px]"}`}>

                                                                <span>{item.name}</span>

                                                            </div>

                                                            <div className={`${isTabletView ? "w-[80px]" : "w-[120px]"}`}>

                                                                {

                                                                    item?.variant?.name && <span className="text-color6">({item?.variant?.name})</span>

                                                                }

                                                                {

                                                                    item?.size && <span className="text-color6">({item?.size})</span>

                                                                }

                                                                {

                                                                    item.buffet_price_for && <span className="text-color6">({item.buffet_price_for == "adult" ? "Adult" : "Kids"})</span>

                                                                }

                                                                <span className=" ml-2 px-2 py-[1px] bg-color7 text-xs rounded-full">New</span>

                                                            </div>

                                                            

                                                            <div>

                                                                <span className="text-color6">x{item.quantity}</span>

                                                            </div>

                                                            <OrderItemPriceDisplay item={item} orderType={order?.order_type} />

                                                            {/* Replace Item */}

                                                            <div className=" flex items-center justify-center p-2 -mr-2 relative">

                                                                <span onClick={()=> setReplaceItem(item)} className=" cursor-pointer"><FaEllipsisVertical /></span>

                                                                {

                                                                    (replaceItem?.order_item_id === item?.order_item_id) &&

                                                                    <div ref={itemReplacePopupRef} className=" w-[170px] bg-color2 flex flex-col gap-1 absolute z-20 top-0 right-1 p-2 border border-color3 rounded-md ">

                                                                        <div onClick={()=> setReplaceItem(null)} className=" absolute top-1 right-1 text-red-600 cursor-pointer"><FaXmark size={20} /></div>

                                                                        <div onClick={() => { setViewItemDetails(item); setReplaceItem(null); }} className=" hover:text-color6 cursor-pointer">View Details</div>

                                                                        {

                                                                            hasPermission("take_orders.take_order.replace_items") &&

                                                                            <> 

                                                                                <div onClick={()=> setReplaceSameItem(item)} className=" hover:text-color6 cursor-pointer">Replace with same</div>

                                                                                {!(item.is_complementary || item.is_loyalty_free || item.is_offer_free || item.is_free || item.calculated_price === 0) && (
                                                                            <div onClick={()=>{ dispatch(setReplaceItemState(item)); setOrderDetailsId(null); setActiveOrderSection("New Order") }} className=" hover:text-color6 cursor-pointer">Replace with another</div>
                                                                        )}

                                                                            </>

                                                                        }

                                                                    </div>

                                                                }

                                                                

                                                            </div>

                                                        </div>

                                                        <OrderItemComboBreakdown comboItems={item?.combo_items} isTabletView={isTabletView} />
                                                        <OrderItemCourseBreakdown courseItems={item?.course_items} item={item} isTabletView={isTabletView} />
                                                        <OrderItemSpecialMenuBreakdown specialMenu={item?.special_menu} item={item} isTabletView={isTabletView} />
                                                        <OrderItemMixAndMatchBreakdown items={item?.mix_and_match_items || item?.selected_items || item?.categories} isTabletView={isTabletView} />
                             <OrderItemCustomizationBreakdown item={item} isTabletView={isTabletView} />

                                                    </div>

                                                ))

                                            }

                                        </div>

                                        :

                                        <div key={item?.order_item_id || item?.id || index} className={`${isTabletView ? "mb-1.5" : "mb-2"} flex flex-col`}>
                                            <div title={item.is_complementary ? "Complementary Item" : ""} className={`${isTabletView ? "p-1 text-xs gap-2" : "p-2 gap-4"} bg-color3 flex items-center justify-center rounded`}>

                                                <div className={`${isTabletView ? "w-[150px]" : "w-[220px]"} flex flex-col items-start justify-center`}>

                                                    <span>{item.name}</span>

                                                    {item.is_offer_discount && (

                                                        <span className=" text-[9px] bg-emerald-600/30 text-emerald-400 border border-emerald-500/50 px-1 py-0.2 rounded font-medium mt-0.5">

                                                            🏷️ Discount Offer

                                                        </span>

                                                    )}

                                                </div>

                                                <div className={`${isTabletView ? "w-[80px]" : "w-[120px]"} flex items-center`}>

                                                    {

                                                        item?.variant?.name && <span className="text-color6">({item?.variant?.name})</span>

                                                    }

                                                    {

                                                        item?.size && <span className="text-color6">({item?.size})</span>

                                                    }

                                                    {

                                                        item.buffet_price_for && <span className="text-color6">({item.buffet_price_for == "adult" ? "Adult" : "Kids"})</span>

                                                    }

                                                </div>

                                                <div className={`flex items-center ${isTabletView ? "w-[50px]" : "w-[70px]"}`}>

                                                    <span className="text-color6">x{item.quantity}</span>

                                                </div>

                                                <OrderItemPriceDisplay item={item} orderType={order?.order_type} />

                                                {/* Replace Item */}

                                                <div className=" flex items-center justify-center p-2 -mr-2 relative">

                                                    <span onClick={()=> setReplaceItem(item)} className=" cursor-pointer"><FaEllipsisVertical /></span>

                                                    {

                                                        (replaceItem?.order_item_id === item?.order_item_id) &&

                                                        <div ref={itemReplacePopupRef} className=" w-[170px] bg-color2 flex flex-col gap-1 absolute z-20 top-0 right-1 p-2 border border-color3 rounded-md ">

                                                            <div onClick={()=> setReplaceItem(null)} className=" absolute top-1 right-1 text-red-600 cursor-pointer"><FaXmark size={20} /></div>

                                                            <div onClick={() => { setViewItemDetails(item); setReplaceItem(null); }} className=" hover:text-color6 cursor-pointer">View Details</div>

                                                            {

                                                                hasPermission("take_orders.take_order.replace_items") && (

                                                                    <> 

                                                                        <div onClick={()=> setReplaceSameItem(item)} className=" hover:text-color6 cursor-pointer">Replace with same</div>

                                                                        {!(item.is_complementary || item.is_loyalty_free || item.is_offer_free || item.is_free || item.calculated_price === 0) && (
                                                                            <div onClick={()=>{ dispatch(setReplaceItemState(item)); setOrderDetailsId(null); setActiveOrderSection("New Order"); if(window?.location?.pathname == "/table") navigate('/take-order') }} className=" hover:text-color6 cursor-pointer">Replace with another</div>
                                                                        )}

                                                                    </>

                                                                )

                                                            }

                                                        </div>

                                                    }

                                                    

                                                </div>

                                            </div>

                                            <OrderItemComboBreakdown comboItems={item?.combo_items} isTabletView={isTabletView} />
                                            <OrderItemCourseBreakdown courseItems={item?.course_items} item={item} isTabletView={isTabletView} />
                                            <OrderItemSpecialMenuBreakdown specialMenu={item?.special_menu} item={item} isTabletView={isTabletView} />
                                            <OrderItemMixAndMatchBreakdown items={item?.mix_and_match_items || item?.selected_items || item?.categories} isTabletView={isTabletView} />
                                            <OrderItemCustomizationBreakdown item={item} isTabletView={isTabletView} />

                                        </div>

                                    }

                                    </>

                                ))

                            }

                        </div>

                    </div>

                    <div className="shrink-0">

                        <h2 className={`font-semibold ${isTabletView ? "text-sm mb-0.5" : "text-base mb-1"}`}>Notes</h2>

                        <div className={`bg-color3 ${isTabletView ? "p-1" : "p-1.5"} rounded-sm`}>

                            <p className={`${isTabletView ? "h-[28px] text-xs" : "h-[36px] text-sm"} text-color6 overflow-y-auto pb-0.5`}>{order?.note || "No notes"}</p>

                        </div>

                    </div>

                    {/* Spend Offer Banner */}
            {(order?.eligible_spend_offers?.length > 0 || order?.applied_spend_offer) && (
                <div className={`shrink-0 mt-1 p-1.5 bg-emerald-950/40 border border-emerald-500/30 rounded-md flex items-center justify-between text-white`}>
                    <div className="flex items-center gap-2">
                        <span className="text-base">🎁</span>
                        <div className="flex flex-col">
                            <span className="text-xs font-semibold text-emerald-400">
                                {order.applied_spend_offer ? "Offer Applied" : "Spend Offers Available"}
                            </span>
                            <span className="text-[10px] text-gray-400">
                                {order.applied_spend_offer 
                                    ? order.applied_spend_offer.name 
                                    : `${order.eligible_spend_offers.length} eligible offer(s)`}
                            </span>
                        </div>
                    </div>
                    <button 
                        onClick={() => setShowSpendOfferModal(true)} 
                        className="px-2.5 py-1 bg-emerald-500 hover:bg-emerald-600 text-black font-bold text-xs rounded transition-colors"
                    >
                        {order.applied_spend_offer ? "Change" : "Apply"}
                    </button>
                </div>
            )}

            <div className={`shrink-0 ${isTabletView ? "mt-1" : "mt-1.5"} flex flex-col gap-1`}>

                <div className={`bg-color3 ${isTabletView ? "p-1.5 text-sm" : "p-2"} flex justify-between items-center rounded-sm`}> 

                    <span className="font-semibold">Order Total</span>

                    <span className="text-color6 font-semibold">£{orderTotalAmount.toFixed(2)}</span>

                </div>

                {hasAdvance && (
                    <div className={`bg-emerald-950/40 border border-emerald-500/30 ${isTabletView ? "px-1.5 py-1 text-xs" : "px-2 py-1.5 text-sm"} flex justify-between items-center text-emerald-400 rounded-sm`}> 
                        <div className="flex items-center gap-1.5 min-w-0">
                            <span className="font-medium truncate">💳 {advanceInfo.label}</span>
                            {advanceInfo.uniqueId && (
                                <span className="bg-emerald-900/70 border border-emerald-600/50 text-[10px] px-1.5 py-0.2 rounded font-mono text-emerald-300 shrink-0">
                                    {advanceInfo.uniqueId}
                                </span>
                            )}
                        </div>
                        <span className="font-bold shrink-0 text-emerald-400">-£{advanceInfo.advanceAmount.toFixed(2)}</span>
                    </div>
                )}

                <div className={`bg-color3 ${isTabletView ? "p-1.5 text-sm" : "p-2 text-base"} flex justify-between items-center font-bold text-amber-400 rounded-sm border-t border-color4/30`}> 
                    <span>TOTAL TO PAY</span>
                    <span>£{totalToPayAmount.toFixed(2)}</span>
                </div>

            </div>



            {

                activeTableName && order?.category_stage && (
                    <div className="shrink-0">
                        <FoodServingStatus isTabletView={isTabletView} />
                    </div>
                )

            }



            <div className={`shrink-0 ${isTabletView ? "mt-1.5 gap-1.5" : "mt-2 gap-2"} flex flex-col`}>

                        <div className={`flex ${isTabletView ? "gap-1.5" : "gap-2"}`}>

                            <button onClick={()=>{ if(hasPermission("take_orders.take_order.edit_order")){ continueOrder()} else { toast.error("You do not have permission to edit this order."); }}} className={`w-full ${isTabletView ? "p-1.5 py-2 text-xs" : "p-2 text-sm"} ${hasPermission("take_orders.take_order.edit_order") ? "bg-blue-500" : "bg-gray-500"} font-bold rounded-md flex flex-col items-center justify-center gap-0.5 transition-opacity ${isPaid ? "opacity-50 cursor-not-allowed" : ""}`}>

                                <span>Edit Order</span>

                            </button>

                            <button onClick={() =>{ if(hasPermission("take_orders.take_order.print_kitchen_copy")){ setShowKitchenPrintModal(true); } else { toast.error("You do not have permission to print the kitchen order."); } }} className={`w-full ${isTabletView ? "p-1.5 py-2 text-xs" : "p-2 text-sm"} ${hasPermission("take_orders.take_order.print_kitchen_copy") ? "bg-sky-500" : "bg-gray-500"} font-bold rounded-md flex flex-col items-center justify-center gap-0.5`}>

                                <span>Print Kitchen</span>

                            </button>

                            <button onClick={() => printCustomerCopy(order?.id)} className={`w-full ${isTabletView ? "p-1.5 py-2 text-xs" : "p-2 text-sm"} bg-cyan-500 font-bold rounded-md flex flex-col items-center justify-center gap-0.5`}>

                                <span>Print Customer</span>

                            </button>

                        </div>

                        <div className={`flex ${isTabletView ? "gap-1.5" : "gap-2"}`}>

                            <button onClick={()=> { if(!hasPermission("take_orders.take_order.set_time")){ toast.error("You do not have permission to set the time for this order."); return;} else { if (isPaid) return toast.error("Order is paid. No changes allowed"); setSetTimePage(true); }}} className={`w-full ${isTabletView ? "p-1.5 py-2 text-xs" : "p-2 text-sm"} ${hasPermission("take_orders.take_order.set_time") ? "bg-green-500" : "bg-gray-500"} font-bold rounded-md flex flex-col items-center justify-center gap-0.5 transition-opacity ${isPaid ? "opacity-50 cursor-not-allowed" : ""}`}>

                                <span>Set Time</span>

                            </button>

                            <button onClick={()=> { if(hasPermission("take_orders.take_order.convert")){ if (isPaid) return toast.error("Order is paid. No changes allowed"); if(order?.reservation?.table?.name) return toast.error("Cannot convert order with a reserved table"); setConvertOrder(true); } else { toast.error("You do not have permission to convert this order."); }}} className={`w-full ${isTabletView ? "p-1.5 py-2 text-xs" : "p-2 text-sm"} ${hasPermission("take_orders.take_order.convert") ? "bg-emerald-500" : "bg-gray-500"} font-bold rounded-md flex flex-col items-center justify-center gap-0.5 transition-opacity ${isPaid ? "opacity-50 cursor-not-allowed" : ""}`}>

                                <span>Convert</span>

                            </button>

                            <button onClick={()=> { if(!hasPermission("take_orders.take_order.delay_order")){ toast.error("You do not have permission to delay this order."); return;} else { setShowDelayOrderModal(true); }}} className={`w-full ${isTabletView ? "p-1.5 py-2 text-xs" : "p-2 text-sm"} ${hasPermission("take_orders.take_order.delay_order") ? "bg-teal-500" : "bg-gray-500"} font-bold rounded-md flex flex-col items-center justify-center gap-0.5 transition-opacity `}>

                                <span>Delay Order</span>

                            </button>

                        </div>

                        <div className={`flex ${isTabletView ? "gap-1.5" : "gap-2"}`}>

                            <button onClick={() =>{ if(!hasPermission("take_orders.take_order.replace_order")){ toast.error("You do not have permission to replace this order."); return;} else { handleReplaceOrder(order?.id); }}} className={`w-full ${isTabletView ? "p-1.5 py-2 text-xs" : "p-2 text-sm"} ${hasPermission("take_orders.take_order.replace_order") ? "bg-cyellow" : "bg-gray-500"} font-bold rounded-md flex flex-col items-center justify-center gap-0.5`}>

                                <span>Replace Order </span>

                            </button>

                            <button onClick={()=> { if(!hasPermission("take_orders.take_order.complementary")){ toast.error("You do not have permission to add complementary items."); return;} else { setComplementaryPage(true); }}} className={`w-full ${isTabletView ? "p-1.5 py-2 text-xs" : "p-2 text-sm"} ${hasPermission("take_orders.take_order.complementary") ? "bg-amber-500" : "bg-gray-500"} font-bold rounded-md flex flex-col items-center justify-center gap-0.5`}>

                                <span>Complementary </span>

                            </button>

                            <button onClick={()=> { if(!hasPermission("take_orders.take_order.billing")){ toast.error("You do not have permission to access billing."); return;} else { setBillPage(true); }}} className={`w-full ${isTabletView ? "p-1.5 py-2 text-xs" : "p-2 text-sm"} ${hasPermission("take_orders.take_order.billing") ? "bg-orange-500" : "bg-gray-500"} font-bold rounded-md flex flex-col items-center justify-center gap-0.5`}>

                                <span>Billing</span>

                            </button>

                        </div>

                    </div>

            </div>





            {showReplaceOrderPopup && (

                <div className="fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50">

                    <div className={`${isTabletView ? "w-[300px] p-4" : "w-[400px] p-6"} bg-color2 rounded-md relative`}>

                        <div onClick={cancelReplaceOrder} className="absolute top-2 right-2 text-red-600 cursor-pointer">

                            <FaXmark size={20} />

                        </div>

                        <h2 className={`font-semibold ${isTabletView ? "text-lg" : "text-xl"} mb-4 text-center`}>Confirm Replace Order</h2>

                        <p className={`${isTabletView ? "text-sm" : "text-base"} mb-4`}>Are you sure you want to replace this order?</p>

                        <div className={`flex ${isTabletView ? "flex-col gap-2" : "gap-4"}`}>

                            <button onClick={confirmReplaceOrder} className={`w-full ${isTabletView ? "p-2 text-sm" : "p-3 text-base"} bg-green-500 font-bold rounded-md`}>Yes, Replace</button>

                            <button onClick={cancelReplaceOrder} className={`w-full ${isTabletView ? "p-2 text-sm" : "p-3 text-base"} bg-red-500 font-bold rounded-md`}>No, Cancel</button>

                        </div>

                    </div>

                </div>

            ) /* Confirmation popup */}



            <PrintKitchenCopyModal

                isOpen={showKitchenPrintModal}

                onClose={() => setShowKitchenPrintModal(false)}

                order={order}

                isTabletView={isTabletView}

            />



            <DelayOrderModal

                isOpen={showDelayOrderModal}

                onClose={() => setShowDelayOrderModal(false)}

                isTabletView={isTabletView}

                orderId={order?.id}

                onSuccess={(updatedOrder) => {

                    if (updatedOrder) {

                        dispatch(setOrderData(updatedOrder));

                    }

                }}

            />

            <SpendOfferModal

                isOpen={showSpendOfferModal}

                onClose={() => setShowSpendOfferModal(false)}

                isTabletView={isTabletView}

                order={order}

                onSuccess={(updatedOrder) => {

                    if (updatedOrder) {

                        dispatch(setOrderData(updatedOrder));

                        if (setCheckoutData) {

                            setCheckoutData(updatedOrder);

                        }

                    }

                }}

            />



            {

                replaceSameItem &&

                <div className=" fixed top-0 left-0 w-screen h-screen bg-black/70 flex items-center justify-center z-50 ">



                    <div className={` ${isTabletView ? "w-[300px] p-4" : "w-[400px] p-6"} bg-color2 rounded-md relative`}>

                        <div onClick={()=> setReplaceSameItem(null)} className=" absolute top-2 right-2 text-red-600 cursor-pointer"><FaXmark size={20} /></div>

                        <h2 className={` font-semibold ${isTabletView ? "text-lg" : "text-xl"} mb-4 text-center`}>{replaceSameItem?.name}</h2>

                        <p className={` ${isTabletView ? "text-sm" : "text-base"} mb-4`}>

                            Are you sure you want to replace 

                            <span className=" font-bold text-color6"> {replaceSameItem?.name} </span>

                            {

                                replaceSameItem?.variant?.name && <span className="text-color6"> ({replaceSameItem?.variant?.name}) </span>

                            }

                            {

                                replaceSameItem?.size && <span className="text-color6"> ({replaceSameItem?.size}) </span>

                            }

                            {

                                replaceSameItem.buffet_price_for && <span className="text-color6"> ({replaceSameItem.buffet_price_for == "adult" ? "Adult" : "Kids"}) </span>

                            }

                            with another 

                            <span className=" font-bold text-color6"> {replaceSameItem?.name} </span>

                            {

                                replaceSameItem?.variant?.name && <span className="text-color6"> ({replaceSameItem?.variant?.name}) </span>

                            }

                            {

                                replaceSameItem?.size && <span className="text-color6"> ({replaceSameItem?.size}) </span>

                            }

                            {

                                replaceSameItem.buffet_price_for && <span className="text-color6"> ({replaceSameItem.buffet_price_for == "adult" ? "Adult" : "Kids"}) </span>

                            }

                            ?

                        </p>

                        <div>

                            <label className={` ${isTabletView ? "text-sm" : "text-base"} mb-2 block`}>Reason for replacement:</label>

                            <textarea value={reason} onChange={(e) => setReason(e.target.value)} className={` ${isTabletView ? "text-sm p-2" : "text-base p-3"} mb-4 w-full bg-color3 rounded-md resize-none`} rows={4} placeholder="Enter reason for replacement..."></textarea>

                        </div>

                        <div className={` flex ${isTabletView ? "flex-col gap-2" : "gap-4"}`}>

                            <button onClick={()=> { console.log("Replacing item with same:", replaceSameItem); replaceSameItemConfirm(replaceSameItem); }} className={` w-full ${isTabletView ? "p-2 text-sm" : "p-3 text-base"} bg-green-500 font-bold rounded-md`}>Yes, Replace</button>

                            <button onClick={()=> setReplaceSameItem(null)} className={` w-full ${isTabletView ? "p-2 text-sm" : "p-3 text-base"} bg-red-500 font-bold rounded-md`}>No, Cancel</button>

                        </div>

                    </div>

                </div>

            }

            <OrderedItemDetailsModal 
                isOpen={!!viewItemDetails} 
                onClose={() => setViewItemDetails(null)} 
                item={viewItemDetails} 
                orderType={order?.order_type} 
                isTabletView={isTabletView} 
            />

        </>

        )}

    </div>

  );

}

export default OrderDetails;